/**
 * `useHasMounted`: true from the first client render after mount, false during the static-export
 * prerender and the first hydration pass.
 *
 * Callers return `null` until it is true, so nothing they render is in the prerendered HTML.
 * About 23 importers, for example `components/Login/Login.tsx` (which reads `sessionStorage`),
 * `components/Register/Register.tsx` and `pages/about-us/index.tsx`. Separately,
 * `components/NextLayouts/RootLayout.tsx` wraps every page in the shared `HasMounted` component,
 * as a workaround for `@artsy/fresnel` hydration errors.
 */
import React, { useEffect } from "react";

const useHasMounted = () => {
	const [hasMounted, setHasMounted] = React.useState<boolean>(false);

	useEffect(() => {
		setHasMounted(true);
	}, []);

	return hasMounted;
};

export default useHasMounted;
